import React, { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { Card, Badge, StatCard } from '../components/Common';

export default function ClientLicensing() {
  const { apiFetch, user } = useAuth();
  const [licenses, setLicenses] = useState([]);
  const [activeUsers, setActiveUsers] = useState(0);

  const load = useCallback(async () => {
    if (!user?.clientId) return;
    const res = await apiFetch(`/licenses/client/${user.clientId}`);
    if (res.ok) {
      const data = await res.json();
      setLicenses(data.licenses || []);
      setActiveUsers(data.activeUsers || 0);
    }
  }, [apiFetch, user?.clientId]);

  useEffect(() => { load(); }, [load]);

  const isExpired = (lic) => lic.expiry_date && new Date(lic.expiry_date) < new Date();
  const activeLic = licenses.find(l => l.status === 'Active' && !isExpired(l));
  const daysRemaining = activeLic?.expiry_date
    ? Math.ceil((new Date(activeLic.expiry_date) - new Date()) / (1000 * 60 * 60 * 24))
    : null;

  return (
    <div>
      <h1 style={{ fontSize: 24, fontWeight: 700, marginBottom: 24 }}>Licensing</h1>

      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(180px, 1fr))', gap: 16, marginBottom: 24 }}>
        <StatCard label="Active Users" value={activeUsers} icon="👥" color="#3b82f6" />
        <StatCard label="Seat Limit" value={activeLic?.seat_count != null ? activeLic.seat_count : 'Unrestricted'} icon="💺" color="#8b5cf6" />
        <StatCard label="License Status" value={activeLic ? (isExpired(activeLic) ? 'Expired' : activeLic.status) : 'None'} icon="📄"
          color={activeLic?.status === 'Active' && !isExpired(activeLic) ? '#22c55e' : '#ef4444'} />
        <StatCard label="Days Remaining" value={daysRemaining != null ? (daysRemaining > 0 ? daysRemaining : 'Expired') : 'N/A'} icon="📅"
          color={daysRemaining != null && daysRemaining > 30 ? '#22c55e' : daysRemaining > 0 ? '#f59e0b' : '#ef4444'} />
      </div>

      {licenses.length > 0 ? (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
          {licenses.map(lic => (
            <Card key={lic.id} style={{ padding: 16 }}>
              <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
                <code style={{ fontSize: 14, fontWeight: 600, color: 'var(--primary)', background: 'var(--bg-input)', padding: '2px 8px', borderRadius: 4 }}>
                  {lic.license_key}
                </code>
                <Badge style={{
                  background: lic.status === 'Active' && !isExpired(lic) ? '#22c55e' :
                    lic.status === 'Suspended' ? '#f59e0b' : '#ef4444',
                  color: '#fff'
                }}>
                  {isExpired(lic) ? 'Expired' : lic.status}
                </Badge>
              </div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12, fontSize: 14 }}>
                <div><strong>Seats:</strong> {lic.seat_count != null ? `${activeUsers} / ${lic.seat_count}` : 'Unrestricted'}</div>
                <div><strong>Active Date:</strong> {lic.active_date ? new Date(lic.active_date).toLocaleDateString() : '—'}</div>
                <div><strong>Expiry Date:</strong> {lic.expiry_date ? new Date(lic.expiry_date).toLocaleDateString() : 'Never'}</div>
              </div>
            </Card>
          ))}
        </div>
      ) : (
        <Card style={{ padding: 40, textAlign: 'center', color: 'var(--text-secondary)' }}>
          <div style={{ fontSize: 32, marginBottom: 8 }}>📄</div>
          <div style={{ fontSize: 14 }}>No licensing information available.</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>Contact your account manager for licensing details.</div>
        </Card>
      )}
    </div>
  );
}
